/** Helper methods to transform model fields values to client types */

/** CONVERT TYPES METHODS */
export function toNumber(v: string|number): number {
    /** if for some reason the value is null or undefined return 0 */
    return Number(v ?? 0);
}

export function toNullableNumber(v?: string|number|null): number|null {
    if (v === undefined || v === null) {
        return null;
    }

    if ((v + '').trim() === '') {
        return null;
    }

    return Number(v);
}

export function toBoolean(v: any): boolean {
    return Boolean(v);
}

export function isSet<T>(v: T): v is NonNullable<T> {
    return v !== undefined && v !== null;
}


/** STORES HELPER METHODS */
export function getNullableChangesOrModel<T>(changedField?: T, modelField?: T): T|null {
    if(changedField === null) {
        return null;
    }

    return changedField ?? modelField ?? null;
}
